module.exports = __webpack_public_path__ + "img/i2.5348d19c.png";